import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { ArtikelPreis } from '../entities/produkte/artikelpreis.entity';
import { KalkulationsGruppe } from '../entities/produkte/kalkulationsgruppe.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class ArtikelPreisService extends ODataEntityService<ArtikelPreis> {
  constructor(protected client: ODataClient) {
    super(client, 'ArtikelPreis', 'entities.produkte.ArtikelPreis');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public kalkGruppe(entity: EntityKey<ArtikelPreis>): ODataNavigationPropertyResource<KalkulationsGruppe> {
    return this.entity(entity).navigationProperty<KalkulationsGruppe>('kalkGruppe');
  }
  public status(entity: EntityKey<ArtikelPreis>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<ArtikelPreis>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
